import { useEffect } from 'react';
import { UseFormMethods } from 'react-hook-form';

export type UseConfigureInterfaceValidationParams = {
  getValues: UseFormMethods<AddVmConfigureFormValues>['getValues'];
  trigger: UseFormMethods<AddVmConfigureFormValues>['trigger'];
  watch: UseFormMethods<AddVmConfigureFormValues>['watch'];
  interfaces: NetworkToConfigure[];
};

export function useConfigureInterfaceValidation({
  getValues,
  trigger,
  watch,
  interfaces,
}: UseConfigureInterfaceValidationParams): void {
  const interfacesWatcher = watch(['interfaces']);

  useEffect(() => {
    interfaces.forEach((_, index) => {
      const row = getValues().interfaces?.[index];
      if (row?.trunked) {
        trigger(`interfaces.${index}.trunkedNetworks`);
        trigger(`interfaces.${index}.network`);
        trigger(`interfaces.${index}.ipAddress`);
        trigger(`interfaces.${index}.macAddress`);
      } else {
        trigger(`interfaces.${index}.network`);
        trigger(`interfaces.${index}.trunkedNetworks`);
        if (row?.network) {
          trigger(`interfaces.${index}.ipAddress`);
          trigger(`interfaces.${index}.macAddress`);
          trigger(`interfaces.${index}.assignDhcp`);
        }
      }
    });
  }, [trigger, interfacesWatcher, interfaces, getValues]);
}
